export const incrementVisitCounter = () => {
    let counter = parseInt(localStorage.getItem('visitCounter') || 0);
    localStorage.setItem('visitCounter', String(++counter))
};

export const isNotFirstVisit = () => {
    const visitsCount = parseInt(localStorage.getItem('visitCounter') || 0);

    return visitsCount > 1;
};
